import { getCurrentSessionIdToken } from "../queries/AuthToken";

export const getHeaderToken = async () => {
    const token = await getCurrentSessionIdToken();

    return {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + token
    }
}